<div
  [class.bg-blue]="subMenuColor() === 'blue'"
  [class.bg-purple]="subMenuColor() === 'purple'"
  class="relative h-[70px] w-full">
  <div
    [class.bg-blue]="subMenuColor() === 'blue'"
    [class.bg-purple]="subMenuColor() === 'purple'"
    class="centered-with-padding relative z-20 h-full">
    <div class="grid h-full grid-cols-[auto_1fr] items-center gap-x-14">
      <a [routerLink]="menuBlog().menuLinkUrl" class="title-h2">{{ "COMPONENT.MENU-BLOG.THE_BLOG" | translate }}</a>
      <!-- DESKTOP -->
      <div class="hidden h-full desk:flex">
        @for (category of menuBlog().categories; track $index) {
          @let routerLinkActiveClass = subMenuColor() === "purple" ? "bg-purple-hover" : "bg-blue-hover";
          @if (category | menuHasSubItems) {
            <div
              [class.hover:bg-blue-hover]="subMenuColor() === 'blue'"
              [class.hover:bg-purple-hover]="subMenuColor() === 'purple'"
              [routerLinkActive]="['rounded-t-xl', routerLinkActiveClass]"
              class="group relative flex h-full cursor-pointer flex-col items-center justify-center gap-y-2.5 px-5 hover:rounded-t-xl">
              <span class="font-bold">{{ category.label }}</span>
              <div class="h-[7px] w-[14px] rotate-90">
                <app-svg [height]="14" [width]="7" src="assets/icons/caret-right.svg" />
              </div>
              <div
                class="drop-shadow-custom absolute left-0 top-full hidden rounded-b-xl bg-gray-light group-hover:block">
                <div class="flex flex-col">
                  @for (item of category.subItems; track $index) {
                    <a class="block text-nowrap px-5 py-4 last:rounded-b-xl hover:bg-gray/20" [routerLink]="item.url">
                      {{ item.label }}
                    </a>
                  }
                </div>
              </div>
            </div>
          } @else {
            <div
              [routerLinkActive]="routerLinkActiveClass"
              [routerLink]="category.url"
              class="group relative flex h-full cursor-pointer flex-col items-center justify-center gap-y-2.5 px-5 hover:rounded-t-xl">
              <span class="font-bold">{{ category.label }}</span>
            </div>
          }
        }
      </div>
      <div
        (click)="toggleCategories()"
        class="flex translate-y-3.5 cursor-pointer items-center gap-x-2.5 justify-self-end desk:hidden">
        <span class="font-bold">{{ "COMPONENT.MENU-BLOG.THE_SECTIONS" | translate }}</span>
        <app-svg
          [class.rotate-0]="!isCategoriesMenuOpen()"
          [class.rotate-90]="isCategoriesMenuOpen()"
          [height]="14"
          [width]="7"
          class="transition-transform"
          src="assets/icons/caret-right.svg" />
      </div>
    </div>
  </div>

  <!-- MOBILE -->
  <div
    [ngClass]="{
      'opacity-100 pointer-events-auto': isCategoriesMenuOpen(),
      'opacity-0 -translate-y-5 pointer-events-none': !isCategoriesMenuOpen(),
    }"
    class="relative left-0 z-10 max-h-[calc(100svh-106px)] w-full overflow-auto rounded-b-xl bg-white p-5 transition-all duration-300 ease-in-out desk:hidden">
    @for (category of menuBlog().categories; track $index) {
      @if (category | menuHasSubItems) {
        <div class="mb-7 w-full rounded-xl bg-gray-light p-4">
          <div
            class="flex cursor-pointer items-center gap-x-5"
            [class.pb-4]="categoriesToDisplay()[$index]"
            (click)="toggleCategory($index)">
            <span class="font-title text-[30px]">{{ category.label }}</span>
            <app-svg
              [class.rotate-0]="!categoriesToDisplay()[$index]"
              [class.rotate-90]="categoriesToDisplay()[$index]"
              class="transition-transform"
              [height]="14"
              [width]="7"
              src="assets/icons/caret-right.svg" />
          </div>
          <div [class.hidden]="!categoriesToDisplay()[$index]" class="flex flex-col gap-y-4">
            @for (item of category.subItems; track $index) {
              <a [routerLink]="item.url" (click)="toggleCategories()">{{ item.label }}</a>
            }
          </div>
        </div>
      } @else {
        <div class="mb-7 w-full rounded-xl bg-gray-light p-4 last:mb-0">
          <div
            (click)="toggleCategories()"
            [routerLink]="category.url"
            class="flex cursor-pointer items-center gap-x-5">
            <span class="font-title text-[30px]">{{ category.label }}</span>
          </div>
        </div>
      }
    }
  </div>

  <!-- OVERLAY -->
  <div
    (click)="toggleCategories()"
    [ngClass]="{
      'bg-black/40 pointer-events-auto': isCategoriesMenuOpen(),
      'bg-transparent pointer-events-none': !isCategoriesMenuOpen(),
    }"
    class="absolute inset-0 z-[5] block h-[calc(100vh-50px)] overflow-hidden transition-all duration-300 ease-in-out"
    tabindex="-1"></div>
</div>
